// extracted by mini-css-extract-plugin
module.exports = {"cart":"ProductsTourPage_cart__1Mgbn"};